export default "__VITE_ASSET__CFjNMseO__"